import { render, staticRenderFns } from "./DeleteReferenceDialog.vue?vue&type=template&id=4d4e54dc&scoped=true"
import script from "./DeleteReferenceDialog.vue?vue&type=script&lang=js"
export * from "./DeleteReferenceDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteReferenceDialog.vue?vue&type=style&index=0&id=4d4e54dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4e54dc",
  null
  
)

export default component.exports